type Props = {
  mappingInteractionId?: string | null;
  onWatchMapping?: (interactionId: string) => void;
};

export default function JourneysMappingProgress({ mappingInteractionId, onWatchMapping }: Props) {
  return (
    <div className="mt-6 rounded-lg border border-dashed border-gray-200 px-4 py-5">
      <p className="text-sm font-medium text-gray-900">We’re signing in as this test user and mapping journeys</p>
      <p className="mt-2 text-sm leading-relaxed text-gray-600">
        This usually takes several minutes. We’ll click and fill forms as that user, which can change data on your site.
        This isn’t an audit yet — we’re only naming the main signed-in jobs.
      </p>
      <div className="mt-4 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center">
        {mappingInteractionId ? (
          <button
            type="button"
            className="btn btn-primary justify-center"
            onClick={() => onWatchMapping?.(mappingInteractionId)}
          >
            Watch mapping
          </button>
        ) : null}
        <p className="text-sm text-gray-500">You can also open Agent sessions above to watch.</p>
      </div>
    </div>
  );
}
